// extracted by mini-css-extract-plugin
module.exports = {"background":"modal_background__3WGCl","front":"modal_front__39j9k","head":"modal_head__hfka7","body":"modal_body__2bgsT"};